import { ArrowRight, Award } from "lucide-react";
import { useTranslation } from "react-i18next";

const About = ({ onOpenBooking }) => {
  const { t } = useTranslation();
  const credentials = [
    t("about.c1"),
    t("about.c2"),
    t("about.c3"),
    t("about.c4"),
    t("about.c5"),
    t("about.c6"),
    t("about.c7"),
    t("about.c8"),
  ];

  return (
    <section
      id="about"
      data-testid="about-section"
      className="section-padding bg-[#F2F4F0]"
    >
      <div className="max-w-7xl mx-auto">
        {/* About Ivana */}
        <div className="grid md:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="md:col-span-5">
            <div className="relative">
              <img
                src="/assets/ivana-portrait-real.png"
                alt="Ivana Silva"
                className="rounded-3xl shadow-[0_20px_60px_rgba(44,53,36,0.15)] w-full"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#2C3524] rounded-2xl p-6 shadow-xl max-w-[220px]">
                <p className="font-heading text-2xl text-[#DCC286] italic mb-1">Ivana Silva</p>
                <p className="text-white/70 text-xs tracking-[0.15em] uppercase">{t("about.role")}</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-7">
            <span className="overline mb-4 block">{t("about.overline")}</span>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-6xl text-[#2C3524] leading-[1.1] mb-8">
              {t("about.titlePart1")}<br />
              <span className="text-[#C5A059] italic">{t("about.titlePart2")}</span>
            </h2>
            <div className="text-[#4A5543] font-light leading-relaxed space-y-4 md:text-lg">
              <p>{t("about.p1")}</p>
              <p>{t("about.p2")}</p>
              <p className="font-medium text-[#2C3524]">{t("about.p3")}</p>
            </div>

            <button
              onClick={onOpenBooking}
              className="btn-primary mt-10 group"
              data-testid="about-booking-btn"
            >
              {t("about.cta")}
              <ArrowRight className="inline-block ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>

        {/* Credentials */}
        <div className="mt-24 pt-16 border-t border-[#E3DAC9]">
          <div className="grid md:grid-cols-12 gap-12">
            <div className="md:col-span-4">
              <span className="overline mb-4 block">{t("about.credentialsOverline")}</span>
              <h3 className="font-heading text-2xl md:text-3xl text-[#2C3524] leading-tight">
                {t("about.credentialsTitlePart1")}<br />
                {t("about.credentialsTitlePart2")} <span className="italic text-[#C5A059]">{t("about.credentialsTitlePart3")}</span>
              </h3>
              <p className="mt-4 text-[#4A5543] font-light text-sm">
                {t("about.credentialsIntro")}
              </p>
            </div>
            <div className="md:col-span-8">
              <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
                {credentials.map((cred, index) => (
                  <li
                    key={index}
                    className="flex items-start gap-3 group"
                    data-testid={`credential-${index}`}
                  >
                    <Award
                      className="w-4 h-4 text-[#C5A059] flex-shrink-0 mt-1 group-hover:rotate-12 transition-transform"
                      strokeWidth={1.5}
                    />
                    <span className="text-[#4A5543] text-sm font-light leading-relaxed">
                      {cred}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
